import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-version',
  templateUrl: './version.component.html',
  styleUrl: './version.component.less'
})
export class VersionComponent implements OnInit {

  currentVersion: string = "";
  buildDate: any = {};
  constructor() { }

  ngOnInit(): void {
    this.currentVersion = "vSanlamMP-1.0.1";
    this.buildDate = new Date('2024-12-11');
  }
}
